<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="app-page-content" custom-content>
    <div class="row tw-my-2 tw-mx-2">
      <!-- content -->
      <div class="content-section">
        <!-- infinite-scroll -->
        <!-- <div *ngIf="items" infinite-scroll [infiniteScrollDistance]="infiniteScrollDistance"
          [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown()"> -->
        <div *ngIf="items">
          <!-- items -->
          <div
            class="row md:tw-px-5 sm:tw-px-0 tw-pt-2 tw-text-center tw-text-[16px] text-dark"
          >
            <ng-container
              *ngFor="let item of items; trackBy: trackByFunc; let i = index"
            >
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <app-plans-type-module-card
                  [model]="item"
                  [vocabsPath]="tableVocabs"
                  [parentLoading]="buyButtonLoading"
                  (selectedPlanModulePrice)="baseCreateGetApi($event)"
                ></app-plans-type-module-card>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- loading -->
        <div class="tw-flex-center tw-my-5" *ngIf="pageConfig.loading">
          <div
            class="spinner-border text-navyBlue tw-h-[45px] tw-w-[45px]"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <!-- empty -->
        <ng-container *ngIf="!items?.length && !pageConfig.loading">
          <div class="row">
            <div class="tw-w-full">
              <h3 class="tw-text-center tw-text-gray-500 dark:tw-text-gray-300">
                {{ "common.empty" | translate }}
              </h3>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-page-template>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'BuyPlanModule'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
